var _circle, _path, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchCandidates(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "url(#paint0_linear_6344_15557)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8613 8.62042C14.862 6.62115 11.6197 6.62115 9.62042 8.62042C7.62115 10.6197 7.62115 13.862 9.62042 15.8613C11.3915 17.6324 14.1383 17.8323 16.1311 16.4654L18.6237 19.2535C19.0474 19.7294 19.7841 19.749 20.234 19.2991L20.2991 19.234C20.749 18.7841 20.7294 18.0474 20.2535 17.6237L17.4654 15.1311C18.8345 13.1362 18.6324 10.3915 16.8613 8.62042ZM15.6182 14.6182C14.3057 15.9308 12.176 15.9308 10.8634 14.6182C9.55088 13.3057 9.55088 11.176 10.8634 9.86345C12.176 8.55088 14.3057 8.55088 15.6182 9.86345C16.933 11.1782 16.9308 13.3057 15.6182 14.6182Z",
    fill: "#FEFDFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6344_15557",
    x1: 9.70313,
    y1: -2.08238e-8,
    x2: 18.5625,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.50191,
    stopColor: "#6263F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B84FE"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchCandidates);
export default __webpack_public_path__ + "static/media/searchCandidates.40e028a8fe07aaf57a4256c4a45f1436.svg";
export { ForwardRef as ReactComponent };